<ng-template #dialogAddUser let-c="close" let-d="dismiss">
  <div class="p-3">
    <div class="d-flex justify-content-between">
      <div class="logo"></div>

      <div class="close-button" (click)="d('Cross click')"></div>
    </div>
    <div class="modal_container black-text">
      <p class="text-header-modal" translate>customer.newUser</p>

      <form #userForm="ngForm" (ngSubmit)="sendUser(userForm, toggleNewClient)" class="form-vehicle">

        <!-- Name -->
        <div class="form-group">
          <label translate>customer.fullName</label>
          <input type="text" #fullName="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="fullName.invalid && fullName.touched" name="fullName">
        </div>

        <!-- Email -->
        <div class="form-group">
          <label translate>customer.email</label>
          <input type="email" #email="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="email.invalid && email.touched" name="email">
        </div>

        <!-- Password -->
        <div class="form-group">
          <label translate>customer.password</label>
          <input type="text" #password="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="password.invalid && password.touched" name="password">
        </div>

        <!-- Password Repeat -->
        <div class="form-group">
          <label translate>customer.repeatPassword</label>
          <input type="text" #passwordRepeat="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="passwordRepeat.invalid && passwordRepeat.touched" name="passwordRepeat">
        </div>

        <!-- UID -->
        <!-- <div class="form-group">
          <label>UID</label>
          <input type="text" #uid="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="uid.invalid && uid.touched" name="uid">
        </div> -->

        <!-- Application -->
        <div class="form-group" *ngIf="router.url.includes('/root/applications')">
          <label>Application</label>
          <select class="custom-select" name="applicationId" [(ngModel)]="applicationId" required>
            <option value="" disabled>Select Client</option>
            <option value="{{application.id}}">{{application.name}}</option>
          </select>
        </div>

        <!-- Type -->
        <div class="form-group">
          <label translate>customer.typeOfUser</label>
          <select class="custom-select" name="type" ngModel required>
            <!--option value="premium" selected>Premium</option-->
            <option class="option" value="basic">Basic</option>
            <option value="simple">Simple</option>
          </select>
        </div>

        <!-- Customer -->
        <div *ngIf="customers" class="form-group">
          <p class="my-3" translate>Customer</p>
          <div #searchContainer [ngClass]="{'active' : showCustomers}" class="div select-bg search-container w-100"
            style="display: block;">
            <input type="text" readonly class="search"
              style="height: 44px; display: block; width: 100%; padding-left: 12px;" (click)="openCustomers()"
              name="selectedPreset" [placeholder]="selectedCustomer ? selectedCustomer.name : 'Select Customer...'">

            <div class="form-group">
              <div class="prikaz" *ngIf="showCustomers">
                <div class="backdrop" (click)="openCustomers()"></div>
                <div style="z-index: 100; overflow-y: auto;">
                  <div class="divider"></div>
                  <input type="text" class="search-marke" (input)="applyCustomerFilter()"
                    [attr.placeholder]="'user.search' | translate" name="searchCustomersParam"
                    name="searchCustomersParam" [(ngModel)]="searchCustomersParam">
                  <ul style="margin-bottom: 12px;">
                    <li *ngFor="let customer of customersSearch"
                      (click)="showCustomers=!showCustomers; selectCustomer(customer)">
                      {{ customer.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Application -->
        <div class="form-group"
          *ngIf="!router.url.includes('/root/applications') && this.currentUser.role.name !== 'client' && applications">
          <div>
            <div class="choose-window mb-3">
              <p style="color: var(--clr-gray);" translate>customer.existingClients</p>
              <label class="switch_checkbox">
                <input style="display: none;" type="checkbox" name="reflectiveFloor"
                  (change)="toggleNewClient = !toggleNewClient" [ngModel]="toggleNewClient">
                <span class="slider round"></span>
              </label>
              <p style="color: var(--clr-gray);" translate>customer.newClient</p>
            </div>
          </div>

          <div id="existingClients" *ngIf="!toggleNewClient">
            <p class="my-3" translate>customer.application</p>
            <div #searchContainer [ngClass]="{'active' : showClients}" class="div select-bg search-container w-100"
              style="display: block;">

              <input type="text" readonly class="search"
                style="height: 44px; display: block; width: 100%; padding-left: 12px;" (click)="openClients()"
                name="selectedPreset" [placeholder]="selectedClient ? selectedClient.name : ('customer.selectApp' | translate)">

              <div class="form-group">
                <div class="prikaz" *ngIf="showClients">
                  <div class="backdrop" (click)="openClients()"></div>
                  <div style="z-index: 100; overflow-y: auto;">
                    <div class="divider"></div>
                    <input type="text" class="search-marke" (input)="applyClientFilter()"
                      [attr.placeholder]="'user.search' | translate" name="searchClientsParam" name="searchClientsParam"
                      [(ngModel)]="searchClientsParam">
                    <ul style="margin-bottom: 12px;">
                      <li *ngFor="let client of clientsSearch" (click)="showClients=!showClients; selectClient(client)">
                        {{ client.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="newClient" *ngIf="toggleNewClient">
            <p class="text-header-modal" translate>customer.newClient</p>

            <!-- Name -->
            <div class="form-group">
              <label translate>customer.clientName</label>
              <input type="text" #nameClient="ngModel" autocomplete="off" required ngModel class="form-control"
                [class.is-invalid]="nameClient.invalid && nameClient.touched" name="nameClient">
            </div>

            <!-- Description -->
            <div class="form-group">
              <label translate>customer.description</label>
              <input type="text" #description="ngModel" autocomplete="off" required ngModel class="form-control"
                [class.is-invalid]="description.invalid && description.touched" name="description">
            </div>

          </div>
        </div>

        <!-- additionalInvoiceInfo -->
        <div class="form-group">
          <label translate>user.additionalInvInfo</label>
          <textarea type="text" #additionalInvoiceInfo="ngModel" autocomplete="off" ngModel class="form-control"
            [class.is-invalid]="additionalInvoiceInfo.invalid && additionalInvoiceInfo.touched"
            name="additionalInvoiceInfo" rows="2"></textarea>
        </div>

        <div style="min-height: 24px;"></div>

        <button type="submit" class="custom-button" style="width: 120px;" translate>global.save</button>

      </form>
    </div>
  </div>
</ng-template>